/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Footnote_UsersInputs */



/**
* | output |
* | --- |
* | "*** Pro includes up to 3 users. Additional users cost $10/month per active user." |
*
* @param {Signup_Footnote_UsersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_footnote_users = /** @type {((inputs?: Signup_Footnote_UsersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Footnote_UsersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("*** L'offre Pro inclut jusqu'à 3 utilisateurs. Chaque utilisateur actif supplémentaire coûte 10 $/mois.")
	if (locale === "de") return /** @type {LocalizedString} */ ("*** Pro umfasst bis zu 3 Benutzer. Jeder weitere aktive Benutzer kostet 10 $/Monat.")
	if (locale === "it") return /** @type {LocalizedString} */ ("*** Pro include fino a 3 utenti. Ogni utente attivo aggiuntivo costa 10 $/mese.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("*** Тариф Pro включает до 3 пользователей. Каждый дополнительный активный пользователь стоит 10 $ в месяц.")
	if (locale === "es") return /** @type {LocalizedString} */ ("*** Pro incluye hasta 3 usuarios. Cada usuario activo adicional cuesta 10 $/mes.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("*** Pro 最多包含 3 个用户。每增加一个活跃用户每月 10 美元。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("*** Pro には最大 3 ユーザーが含まれます。追加のアクティブユーザーは 1 人あたり月額 10 ドルです。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("*** Pro में अधिकतम 3 उपयोगकर्ता शामिल हैं। हर अतिरिक्त सक्रिय उपयोगकर्ता का शुल्क $10/माह है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("*** O Pro inclui até 3 utilizadores. Cada utilizador ativo adicional custa 10 $/mês.")
	return /** @type {LocalizedString} */ ("*** Pro includes up to 3 users. Additional users cost $10/month per active user.")
});